import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ModulesSection() {
  const modules = [{
    icon: '📚',
    title: 'MÓDULO 1 — Fundamentos Científicos',
    desc: 'Todo lo que necesitas saber sobre la fisiología, la historia y la evidencia real del Kinesiotaping. Aplicarás con criterio, no con fe ciega.'
  }, {
    icon: '✂️',
    title: 'MÓDULO 2 — Materiales, Cortes y Tensiones',
    desc: 'La guía visual y clínica definitiva para seleccionar el corte correcto, la tensión correcta y el material correcto para cada objetivo. El error más común de los terapeutas resuelto de una vez.'
  }, {
    icon: '🗺️',
    title: 'MÓDULO 3 — Protocolos Región por Región',
    desc: 'Hombro, codo, muñeca, columna cervical, columna lumbar, rodilla, tobillo y pie. Protocolos paso a paso listos para aplicar hoy mismo en tu consulta.'
  }, {
    icon: '⚡',
    title: 'MÓDULO 4 — Técnicas Especiales y Aplicaciones Avanzadas',
    desc: 'Técnica linfática, corrección mecánica, aplicaciones deportivas y posturales. Lo que diferencia al practicante básico del clínico avanzado.'
  }, {
    icon: '👥',
    title: 'MÓDULO 5 — Poblaciones Especiales',
    desc: 'Deportistas, embarazadas, niños, adultos mayores. Adaptaciones seguras y específicas para cada grupo.'
  }, {
    icon: '🧠',
    title: 'MÓDULO 6 — Mitos, Realidades y Pensamiento Crítico',
    desc: 'Los 10 mitos más peligrosos del Kinesiotaping destruidos con evidencia. Cuándo la cinta NO es la solución. Cómo integrarla en un plan de tratamiento real.'
  }, {
    icon: '💼',
    title: 'MÓDULO 7 — Tu Práctica Profesional',
    desc: 'Flujo de decisión clínica, documentación, consentimiento informado y cómo convertir esta habilidad en valor económico real y sostenible.'
  }];
  return <section className="py-16 px-4 bg-navy-800" data-id="element-116">
      <div className="max-w-4xl mx-auto" data-id="element-117">
        <FadeIn data-id="element-118">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-cream-100 mb-10" data-id="element-119">
            Dentro del manual encontrarás:
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-120">
          {modules.map((mod, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-121">
              <div className="bg-navy-700/50 border-l-4 border-gold-500 p-6 md:p-8 rounded-r-sm hover:bg-navy-700 transition-colors duration-300" data-id="element-122">
                <div className="flex items-start gap-4" data-id="element-123">
                  <span className="text-3xl mt-1" data-id="element-124">{mod.icon}</span>
                  <div data-id="element-125">
                    <h3 className="text-xl font-bold text-gold-400 mb-3 font-heading tracking-wide" data-id="element-126">
                      {mod.title}
                    </h3>
                    <p className="text-cream-200 leading-relaxed text-lg" data-id="element-127">
                      {mod.desc}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}